import {match} from 'ts-pattern';

import {FinancingSection} from '../types/FinancingSection';

/**
 * Keeps the selected section only while the user may read it, and otherwise falls back to the
 * section the user may read.
 */
export function resolveAccessibleSection(
  selectedSection: FinancingSection,
  canReadFinancing: boolean,
  canReadLeasing: boolean
) {
  return match({selectedSection, canReadFinancing, canReadLeasing})
    .with({selectedSection: 'FINANCING', canReadFinancing: true}, () => 'FINANCING' as const)
    .with({selectedSection: 'LEASING', canReadLeasing: true}, () => 'LEASING' as const)
    .with({canReadFinancing: true}, () => 'FINANCING' as const)
    .otherwise(() => 'LEASING' as const);
}
